import CaptchaInitializer from "../../../Scalesoft.Shared.FrontEnd/Scripts/Captcha/CaptchaInitializer";
import {KeyValuePair} from "../../../Scalesoft.Shared.FrontEnd/Scripts/Global/KeyValuePair";
import {MethodContactType} from "../Enums/MethodContactType";
import IContactViewModel from "../Registration/Interfaces/IContactViewModel";
import IEmailViewModel from "../Registration/Interfaces/IEmailViewModel";
import IPhoneNumberViewModel from "../Registration/Interfaces/IPhoneViewModel";
import {ContactType} from "./Enums/ContactType";
import IUserInfoConfirmationResultContract from "./Interfaces/IUserInfoConfirmationResultContract";

declare const basePath: string;
declare const methodType: MethodContactType;
declare const deleteMethodType: MethodContactType;

export default class ContactApiClient {

    public resendCode(contactId: number, captchaParams: Array<KeyValuePair<string, string>>): JQuery.jqXHR {
        const data = {
            contactId,
        };

        return jq.post({
            url: `${basePath}${this.getMethodType(null)}/ResendConfirmCode`,
            data,
            headers: CaptchaInitializer.setCaptchaHeaders(captchaParams),
        });
    }

    public ensureCodeHasBeenSent(contactId: number): JQuery.jqXHR {
        const data = {
            contactId,
        };

        return jq.post({
            url: `${basePath}Contact/EnsureCodeHasBeenSent`,
            data,
        });
    }

    public verifyContact(
        contactId: number,
        verificationCode: string,
        captchaParams: Array<KeyValuePair<string, string>>,
    )
        : JQuery.jqXHR<IUserInfoConfirmationResultContract> {
        const data = {
            contactId,
            verificationCode,
        };

        return jq.post({
            url: `${basePath}${this.getMethodType(null)}/ConfirmContact`,
            data,
            headers: CaptchaInitializer.setCaptchaHeaders(captchaParams),
        });
    }

    public changeContact(
        contactId: number,
        userId: number,
        contact: IContactViewModel,
        contactType: ContactType,
        captchaParams: Array<KeyValuePair<string, string>>,
        contactMethodType: MethodContactType = null,
    ): JQuery.jqXHR {
        const data = {
            contactId,
            userId,
            contact,
        };

        return jq.post({
            url: `${basePath}${this.getMethodType(contactMethodType)}/Change${this.getContactTypeAddress(contactType)}`,
            data,
            headers: CaptchaInitializer.setCaptchaHeaders(captchaParams),
        });
    }

    public createContact(
        contact: IContactViewModel,
        contactType: ContactType,
        captchaParams: Array<KeyValuePair<string, string>>,
        contactMethodType: MethodContactType = null,
    ): JQuery.jqXHR {
        const data = {
            toUser: contact.userId,
            contact,
        } as JQuery.PlainObject;

        return jq.post({
            url: `${basePath}${this.getMethodType(contactMethodType)}/Create${this.getContactTypeAddress(contactType)}`,
            data,
            headers: CaptchaInitializer.setCaptchaHeaders(captchaParams),
        });
    }

    public deleteContact(
        contactId: number,
        userId: number,
        contactMethodType: MethodContactType = null,
    ): JQuery.jqXHR {
        const data = {
            contactId,
            userId,
        };

        return jq.post({
            url: `${basePath}${this.getMethodType(contactMethodType)}/DeleteContact`,
            data,
        });
    }

    public createAddress(userId: number, addressForm: JQuery): JQuery.jqXHR {
        addressForm.find("[name=\"userId\"]").val(userId);
        const serializedForm = addressForm.serialize();
        return jq.post({
            url: `${basePath}UserData/CreateAddress`,
            data: serializedForm,
        });
    }

    public deleteAddress(userId: number, addressId: number): JQuery.jqXHR {
        return jq.post({
            url: `${basePath}UserData/DeleteAddress`,
            data: {
                userId,
                addressId,
            },
        });
    }

    public editAddress(userId: number, addressForm: JQuery): JQuery.jqXHR {
        addressForm.find("[name=\"userId\"]").val(userId);
        const serializedForm = addressForm.serialize();
        return jq.post({
            url: `${basePath}UserData/EditAddress`,
            data: serializedForm,
        });
    }

    public getEmailCard(
        viewModel: IEmailViewModel,
        index: number, cardViewModelPrefix: string,
        contactMethodType: MethodContactType = null,
    ): JQuery.jqXHR {
        const url = `${basePath}${this.getMethodType(contactMethodType)}/GetEmailCard`;
        const data = {
            viewModel,
            index,
            cardViewModelPrefix,
        };

        return jq.post(
            {
                url,
                data,
            },
        );
    }

    public getPhoneCard(
        viewModel: IPhoneNumberViewModel,
        index: number,
        cardViewModelPrefix: string,
        contactMethodType: MethodContactType = null,
    ): JQuery.jqXHR {
        const url = `${basePath}${this.getMethodType(contactMethodType)}/GetPhoneNumberCard`;
        const data = {
            viewModel,
            index,
            cardViewModelPrefix,
        };

        return jq.post(
            {
                url,
                data,
            },
        );
    }

    public getContactType(): MethodContactType {
        return methodType;
    }

    private getMethodType(contactMethodType: MethodContactType): string {
        const comparedMethodType = contactMethodType === null ? methodType : contactMethodType;
        switch (comparedMethodType) {
            case MethodContactType.Temporary:
                return "TemporaryContact";
            case MethodContactType.Permanent:
                return "Contact";
        }

        return null;
    }

    private getContactTypeAddress(contactType: ContactType): string {
        switch (contactType) {
            case ContactType.Email:
                return "email";
            case ContactType.PhoneNumber:
                return "phone";
        }

        return null;
    }
}
